import React from 'react';
import type { Holiday } from '../../../../types';

type Props = {
  holiday: Holiday,
  onEditModalOpen: (holiday: Holiday) => void,
}

const HolidaysTableRow = (props: Props) => {
  const { holiday, onEditModalOpen } = props;

  return (
    <div
      className="table-row with-cursor"
      onClick={() => onEditModalOpen(holiday)}
    >
      <div className="single-column">
        {holiday.date}
      </div>
      <div className="single-column">
        {holiday.description}
      </div>
    </div>
  );
};

export default HolidaysTableRow;
